import { jsx as _jsx } from "react/jsx-runtime";
import BackToButton from "./BackToButton";
import { emptyFilters, setFilters } from "../../providers/FilterProvider";
import { useContext } from "react";
import { FilterRestrictionContext } from "../../providers/FilterRestrictionProvider";
export var FilterClearingBackToButton = function (_a) {
    var backUrl = _a.backUrl, title = _a.title;
    var clearFilters = function () { return setFilters(emptyFilters); };
    var setRestrictions = useContext(FilterRestrictionContext).setRestrictions;
    var handleFilters = function () {
        clearFilters();
        setRestrictions({});
    };
    return (_jsx(BackToButton, { title: title, backUrl: backUrl, onClick: handleFilters }));
};
